module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/accordian/accordian-style4/accordian-style4.component.scss
// module id = ./src/app/features/accordian/accordian-style4/accordian-style4.component.scss
// module chunks = main